<template>
  <div class="content-wrapper questionnare-wrapper questionnare-question-4">
    <div class="d-flex align-items-start justify-content-center full-height">
      <div class="center full-width">
        <div class="small-text uppercase">Question 2 of 4</div>
        <h3 class="my-4 general-title">What kind of cyclist are you?</h3>
        <div class="question-container my-9 d-flex">
          <button
            class="btn btn-outline-primary questionnaire-prev"
            type="button"
            value="Previous question"
            v-on:click="$emit('go-back')"
          >
            Previous question
            </button>
          <select class="center" name="often" v-model="inputOften">
            <option selected disabled>HOW OFTEN DO YOU RIDE?</option>
            <option value="once a week">ONCE A WEEK</option>
            <option value="weekends">WEEKENDS</option>
            <option value="3-5 times a week">3 - 5 TIMES A WEEK</option>
            <option value="daily">DAILY</option>
          </select>
          <select class="center" name="far" v-model="inputFar">
            <option selected disabled>HOW FAR DO YOU RIDE?</option>
            <option value="<100">&LT;100 KMS PER MONTH</option>
            <option value="200">200 KMS PER MONTH</option>
            <option value="400">400 KMS PER MONTH</option>
            <option value="600">600 KMS PER MONTH</option>
            <option value=">600">> 600 KMS PER MONTH</option>
          </select>
          <select class="center" name="riderType" v-model="inputRiderType">
            <option selected disabled>WHAT RIDER TYPE ARE YOU?</option>
            <option value="racer">RACER</option>
            <option value="pleasure">PLEASURE</option>
            <option value="urban">URBAN</option>
            <option value="offroad">OFF-ROAD</option>
            <option value="long distance">LONG DISTANCE</option>
          </select>
          <select class="center" name="bikeFit" v-model="inputBikeFit">
            <option selected disabled>HAVE YOU HAD A BIKE FIT?</option>
            <option value="no">NO</option>
            <option value="yes">YES</option>
          </select>
          <button
            class="btn btn-outline-primary questionnaire-next"
            type="button"
            value="Next question"
            v-on:click="localGoNext"
          >
          Next question
          </button>
        </div>
      </div>
      <a
        v-on:click="$emit('skip-questionnaire')"
        class="skip-button small-text uppercase"
        href="#"
        >skip questionnaire</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "questionnare-question-2",
  data() {
    return {
      inputs: ["often", "far", "riderType", "bikeFit"],
    };
  },
  props: ["questionAnswers"],
  methods: {
    localGoNext: function () {
      if (this.canGoNext()) {
        this.$emit("go-next");
      }
    },
    canGoNext: function () {
      let err = false;
      let firstFocus = false;
      let requiredField = ["often", "far", "riderType", "bikeFit"];
      for (let i = 0; i < requiredField.length; i++) {
        let fieldName = requiredField[i];
        let k = this.questionAnswers[fieldName];
        if (typeof k == "undefined" || k == "") {
          if (!firstFocus && document.querySelector("[name=" + fieldName + "]")!=null) {
            document.querySelector("[name=" + fieldName + "]").focus();
          }
          err = true;
          firstFocus = true;
        }
      }
      return !err;
    },
  },
  mounted() {
    document.querySelectorAll("select option:first-child").forEach((item) => {
      item.removeAttribute("selected");
      item.setAttribute("selected", "selected");
    });
  },
  computed: {
    inputOften: {
      get() {
        return this.questionAnswers.often;
      },
      set(answer) {
        this.$emit("set-answer", answer, "often");
      },
    },
    inputFar: {
      get() {
        return this.questionAnswers.far;
      },
      set(answer) {
        this.$emit("set-answer", answer, "far");
      },
    },
    inputRiderType: {
      get() {
        return this.questionAnswers.riderType;
      },
      set(answer) {
        this.$emit("set-answer", answer, "riderType");
      },
    },
    inputBikeFit: {
      get() {
        return this.questionAnswers.bikeFit;
      },
      set(answer) {
        this.$emit("set-answer", answer, "bikeFit");
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.questionnare-question-4 {
  input[type="text"],
  input[type="date"],
  select {
    width: 25%;
  }
  .questionnaire-next,
  .questionnaire-prev {
    width: 300px !important;
    padding: 0;
  }
}
</style>